// import { getPageNavigationApi } from '@/api/navigation/navigation';
import { fuzzyFilter } from '@/lib/filters/';
import types from './mutations-types';
import { Container } from '@/lib/classes/dependency-injector';
import { routes } from '@/routes/config';
import { ActionTree } from 'vuex';
import { RootStateShape, NavigationStateShape, TreeNode } from 'store';
import { INavigationServices } from 'services';

const sectionFilter = (filter: string) => (item: TreeNode) => {
	return item?.children?.length && filter !== '';
};

export default {
	getNavigation: ({ commit }) => {
		const navigationService = <INavigationServices>Container.get('navigation-service');

		const structure = navigationService.getStructure(routes);

		commit(types.SET_NAVIGATION_TREE, structure.folderTree);
		commit(types.SET_NAVIGATION_DATA, structure.folderData);
	},

	hideAllSubMenus: ({ state, commit }) => {
		Object.keys(state.navigationData).forEach((itemId) => {
			commit(types.UPDATE_NAVIGATION_ITEM, {
				id: itemId,
				data: {
					isActive: state.navigationData[itemId].isRoot ? true : false
				}
			});
		});
	},

	filterNavigation({ state, commit }, filters: Array<Function>) {
		Object.keys(state.navigationData).forEach((itemId) => {
			const item = state.navigationData[itemId];
			let isHidden = false;

			filters.forEach((filter) => {
				if (filter(item)) {
					isHidden = true;
				}
			});

			commit(types.UPDATE_NAVIGATION_ITEM, {
				id: itemId,
				data: {
					hidden: isHidden
				}
			});
		});
	},

	setNavigationSearchFilter({ commit, dispatch }, filter = '') {
		const filters: Array<Function> = [fuzzyFilter(filter)('title'), sectionFilter(filter)];

		commit(types.SET_SEARCH_FILTER, filter);
		dispatch('filterNavigation', filters);
	}
} as ActionTree<NavigationStateShape, RootStateShape>;
